export enum PanelConnectionType {
	Inline = 'INLINE',
	Inside = 'INSIDE',
	Outside = 'OUTSIDE'
}
